/* 🤖 this file was generated by svg-to-ts */
export const DfIconEyeOpenSquare12: {
  name: 'eye-open-square-12';
  data: string;
} = {
  name: 'eye-open-square-12',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2C0 .9.9 0 2 0zM8 5c-1.28 0-2.5.75-3.68 2.24l-.12.16-.05.07A1 1 0 0 0 4.2 8.6C5.41 10.2 6.68 11 8 11c1.27 0 2.5-.74 3.67-2.24l.12-.15.05-.07a1 1 0 0 0-.05-1.15C10.58 5.8 9.31 5 8 5zm0 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/></svg>`
};
